import React, { useState } from "react";
import axios from "axios";


const useNews = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [permissionData, setPermissionData] = useState([])
    const getPermissionData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/system/permissions_for_demo_example', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setPermissionData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const [permissionGroupData, setPermissionGroupData] = useState([])
    const getPermissionGroupData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/system/permission_group_id_for_demo_example', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setPermissionGroupData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const [data, setData] = useState([])
    const getNewsData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/system/news', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postNewsData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/system/news',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchNewsData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/system/news',
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteNewsData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/system/news',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const patchNewsclick = (data)=>{
        onBefore({
            axiosMode: "patchClick"
        })
        axios.patch('/system/newsclick',
                data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patchClick",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patchClick",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patchClick",
                        status: "error"
                    }
                )
            })
    }
    return {
        PermissionGroupData: permissionGroupData,
        getPermissionGroupData, 
        PermissionData: permissionData, 
        getPermissionData,
        NewsData: data,
        getNewsData,
        postNewsData,
        patchNewsData,
        deleteNewsData,
        patchNewsclick
    }
}
export { useNews }
